// LUMINA · pages/vajra/admin/OfferingMgmtSection.jsx
// Phase 39D: extracted from AdminHub.jsx — 供养管理 (offerings list + status update)
// Phase 72: grouped by offering target with collapsible sections

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, DG, CR, TXT, PANEL } from '../constants';

const RATES = { USD: 1.37, CNY: 0.19 };

export default function OfferingMgmtSection({ token, headers }) {
  const [offeringList,    setOfferingList]   = useState([]);
  const [offeringFilter,  setOfferingFilter] = useState("");
  const [offeringMsg,     setOfferingMsg]    = useState("");
  const [collapsedGroups, setCollapsedGroups] = useState({});  // target_name → bool

  const loadOfferings = useCallback(async () => {
    const url = offeringFilter ? `${API}/vajra/staff/offerings?status=${offeringFilter}` : `${API}/vajra/staff/offerings`;
    const d = await fetch(url,{headers}).then(r=>r.ok?r.json():[]).catch(()=>[]);
    setOfferingList(Array.isArray(d)?d:[]);
  }, [token, offeringFilter]);

  useEffect(() => { loadOfferings(); }, [loadOfferings]);

  // ── Group by target ──
  const grouped = {};
  for (const o of offeringList) {
    const key = o.target_name_zh || `Target #${o.target_id}`;
    if (!grouped[key]) grouped[key] = { name: key, type: o.target_type, items: [], totalCAD: 0, count: 0, cancelledCount: 0 };
    grouped[key].items.push(o);
    if (o.payment_status !== "cancelled") {
      grouped[key].totalCAD += (o.amount_cad || 0);
      grouped[key].count++;
    } else {
      grouped[key].cancelledCount++;
    }
  }
  const groups = Object.values(grouped);

  // Overall summary (all non-cancelled)
  const activeList = offeringList.filter(o => o.payment_status !== "cancelled");
  const sumCNY = activeList.filter(o=>o.currency==="CNY").reduce((s,o)=>s+(o.original_amount||0),0);
  const sumUSD = activeList.filter(o=>o.currency==="USD").reduce((s,o)=>s+(o.original_amount||0),0);
  const sumTotalCAD = activeList.reduce((s,o)=>s+(o.amount_cad||0),0);

  const toggleGroup = (name) => {
    setCollapsedGroups(prev => ({ ...prev, [name]: !prev[name] }));
  };

  // ── Single offering row (unchanged logic from original) ──
  const OfferingRow = ({ o }) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"7px 0 7px 14px",borderBottom:"1px solid rgba(0,0,0,0.03)",fontSize:12}}>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontWeight:500,color:TXT}}>
          {o.donor_name}
          {o.payment_status==="cancelled"&&<span style={{fontSize:10,color:"#999",marginLeft:6,textDecoration:"line-through"}}>已取消</span>}
        </div>
        <div style={{fontSize:10,color:"#aaa"}}>
          {o.payment_method} · {o.created_at?.slice(0,10)}
          {o.currency&&o.currency!=="CAD"&&<> · {o.currency} {o.original_amount}</>}
          {o.received_by&&<> · 收: {o.received_by}</>}
        </div>
        {o.dedication_name&&<div style={{fontSize:10,color:GD}}>回向：{o.dedication_name} {o.dedication_type?`(${o.dedication_type})`:""}</div>}
      </div>
      <div style={{display:"flex",alignItems:"center",gap:8,marginLeft:8}}>
        <span style={{fontSize:12,fontWeight:600,color:GD}}>
          {o.currency&&o.currency!=="CAD"&&<span style={{fontSize:9,fontWeight:400}}>{o.currency} </span>}
          ${o.amount_cad}
        </span>
        {o.is_merit_seat&&<span style={{fontSize:9,padding:"1px 6px",borderRadius:8,background:"rgba(139,105,20,0.1)",color:GD}}>牌位</span>}
        <span style={{fontSize:10,padding:"1px 7px",borderRadius:8,
          background:o.payment_status==="confirmed"?"rgba(6,78,59,0.1)":o.payment_status==="completed"?"rgba(30,58,95,0.1)":o.payment_status==="cancelled"?"rgba(0,0,0,0.05)":"rgba(107,26,26,0.08)",
          color:o.payment_status==="confirmed"?DG:o.payment_status==="completed"?"#1e3a5f":o.payment_status==="cancelled"?"#999":CR}}>
          {o.payment_status}
        </span>
        {o.payment_status==="pending"&&(
          <button onClick={async()=>{
            const r=await fetch(`${API}/vajra/staff/offerings/${o.id}/status`,{method:"PUT",headers,body:JSON.stringify({status:"confirmed"})});
            if(r.ok){setOfferingMsg("✓ 已确认收款");loadOfferings();}else setOfferingMsg("✗ 更新失败");
          }} style={{fontSize:10,padding:"2px 8px",borderRadius:6,cursor:"pointer",background:DG,color:"#fff",border:"none"}}>
            确认
          </button>
        )}
        {o.payment_status==="confirmed"&&!o.reconciled&&(
          <button onClick={async()=>{
            const r=await fetch(`${API}/vajra/staff/offerings/${o.id}/reconcile`,{method:"PUT",headers});
            if(r.ok){setOfferingMsg("✓ 已对账");loadOfferings();}else setOfferingMsg("✗ 对账失败");
          }} style={{fontSize:10,padding:"2px 8px",borderRadius:6,cursor:"pointer",background:"rgba(139,105,20,0.12)",color:GD,border:`1px solid ${GD}`}}>
            到账
          </button>
        )}
        {o.reconciled&&(
          <span style={{fontSize:9,color:"rgba(6,78,59,0.6)",letterSpacing:.5}}>✓ 已对账</span>
        )}
        {!o.reconciled&&o.payment_status!=="cancelled"&&(
          <button onClick={async()=>{
            if(!window.confirm(`取消"${o.donor_name}"的供养记录？`)) return;
            const r=await fetch(`${API}/vajra/staff/offerings/${o.id}`,{method:"DELETE",headers});
            if(r.ok){setOfferingMsg("✓ 已删除");loadOfferings();}else setOfferingMsg("✗ 删除失败");
          }} style={{fontSize:9,padding:"1px 6px",borderRadius:6,cursor:"pointer",background:"transparent",color:"#999",border:"1px solid #ddd"}}>
            ✕
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div style={{background:PANEL,borderRadius:12,padding:"20px",border:`1px solid rgba(0,0,0,0.06)`}}>
      {/* ── Header ── */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
        <div style={{fontSize:15,color:GD,fontWeight:600}}>供养管理</div>
        <div style={{display:"flex",gap:8}}>
          {["","pending","confirmed","completed","cancelled"].map(s=>(
            <button key={s} onClick={()=>{setOfferingFilter(s);}}
              style={{padding:"4px 12px",borderRadius:8,fontSize:12,cursor:"pointer",
                background:offeringFilter===s?GD:"transparent",
                border:`1px solid ${offeringFilter===s?GD:"rgba(139,105,20,0.3)"}`,
                color:offeringFilter===s?"#fff":GD}}>
              {s||"全部"}
            </button>
          ))}
          <button onClick={loadOfferings} style={{fontSize:12,color:GD,background:"transparent",border:`1px solid rgba(212,175,55,0.4)`,borderRadius:6,padding:"4px 12px",cursor:"pointer"}}>↻</button>
          <button onClick={()=>{
            fetch(`${API}/vajra/staff/offerings/export`,{headers}).then(r=>r.blob()).then(blob=>{
              const url=URL.createObjectURL(blob);
              const a=document.createElement("a");
              a.href=url;a.download="offerings_export.csv";a.click();
              URL.revokeObjectURL(url);
            }).catch(()=>setOfferingMsg("导出失败"));
          }} style={{fontSize:12,color:GD,background:"transparent",border:`1px solid rgba(212,175,55,0.4)`,borderRadius:6,padding:"4px 12px",cursor:"pointer"}}>
            ⬇ 导出
          </button>
        </div>
      </div>

      {/* ── Message ── */}
      {offeringMsg&&<div style={{fontSize:12,padding:"8px",borderRadius:6,marginBottom:10,background:offeringMsg.startsWith("✓")?"rgba(6,78,59,0.06)":"rgba(107,26,26,0.06)",color:offeringMsg.startsWith("✓")?DG:CR}}>{offeringMsg}</div>}

      {/* ── Empty state ── */}
      {offeringList.length===0&&<div style={{fontSize:13,color:"#ccc",textAlign:"center",padding:"20px 0"}}>暂无供养记录</div>}

      {/* ── Grouped by target ── */}
      {groups.map(g => {
        const isCollapsed = collapsedGroups[g.name] || false;
        return (
          <div key={g.name} style={{marginBottom:8,border:"1px solid rgba(139,105,20,0.12)",borderRadius:10,overflow:"hidden"}}>
            {/* Group header */}
            <button
              onClick={() => toggleGroup(g.name)}
              style={{
                width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",
                padding:"10px 16px",background:"rgba(139,105,20,0.04)",border:"none",cursor:"pointer",
                fontSize:13,fontWeight:600,color:GD,letterSpacing:".3px"
              }}
            >
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontSize:10,transition:"transform .2s",transform:isCollapsed?"rotate(-90deg)":"none"}}>▼</span>
                <span>{g.name}</span>
                {g.type && (
                  <span style={{fontSize:10,padding:"1px 6px",borderRadius:6,background:"rgba(139,105,20,0.08)",color:"rgba(139,105,20,0.7)",fontWeight:400}}>
                    {g.type==="teacher"?"上师":g.type==="monastery"?"寺院":g.type==="remote_puja"?"远程法会":g.type==="platform"?"平台":"其他"}
                  </span>
                )}
              </div>
              <div style={{display:"flex",gap:16,fontSize:12,fontWeight:400,color:"rgba(0,0,0,0.5)"}}>
                <span>{g.count} 笔</span>
                <span style={{color:GD,fontWeight:600}}>CAD ${g.totalCAD.toFixed(2)}</span>
                {g.cancelledCount > 0 && <span style={{color:"#999",fontSize:10}}>+{g.cancelledCount} 已取消</span>}
              </div>
            </button>

            {/* Group body — individual offerings */}
            {!isCollapsed && (
              <div style={{padding:"0 8px"}}>
                {g.items.map(o => <OfferingRow key={o.id} o={o} />)}
              </div>
            )}
          </div>
        );
      })}

      {/* ── Overall summary ── */}
      {activeList.length > 0 && (
        <div style={{marginTop:12,padding:"10px 14px",background:"rgba(139,105,20,0.04)",borderRadius:8,border:`1px solid rgba(139,105,20,0.1)`,display:"flex",gap:24,flexWrap:"wrap",fontSize:12,color:GD}}>
          <span>共 <b>{groups.length}</b> 个供养对象 · <b>{activeList.length}</b> 条有效记录</span>
          {sumCNY>0&&<span>CNY ¥{sumCNY.toLocaleString()} <span style={{fontSize:10,color:"#aaa"}}>≈ CAD ${(sumCNY*0.19).toFixed(0)}</span></span>}
          {sumUSD>0&&<span>USD ${sumUSD.toLocaleString()} <span style={{fontSize:10,color:"#aaa"}}>≈ CAD ${(sumUSD*1.37).toFixed(0)}</span></span>}
          <span>总 CAD <b>${sumTotalCAD.toFixed(2)}</b></span>
        </div>
      )}
    </div>
  );
}
